import { useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { enqueuePhoto, isOnline } from "@/lib/offlineQueue";
import { Camera, UploadSimple } from "@phosphor-icons/react";

export default function PhotoUploader({ chantierId, onUploaded }) {
  const beforeRef = useRef(null);
  const afterRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file, kind) => {
    setBusy(true);
    try {
      if (!isOnline()) {
        await enqueuePhoto({ chantier_id: chantierId, kind, file, filename: file.name });
        toast.info("Photo enregistrée hors ligne — sera envoyée dès le retour du réseau");
        onUploaded?.();
        return;
      }
      const fd = new FormData();
      fd.append("chantier_id", chantierId);
      fd.append("kind", kind);
      fd.append("file", file);
      try {
        await api.post("/photos", fd, { headers: { "Content-Type": "multipart/form-data" } });
        toast.success("Photo envoyée");
      } catch (netErr) {
        await enqueuePhoto({ chantier_id: chantierId, kind, file, filename: file.name });
        toast.info("Photo mise en file d'attente");
      }
      onUploaded?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-2">
      <button
        onClick={() => beforeRef.current?.click()}
        disabled={busy}
        className="rounded-2xl bg-white/[0.03] border border-dashed border-white/15 hover:border-[#005CFF]/50 p-4 flex flex-col items-center gap-2 active:scale-95 transition-transform"
        data-testid="upload-before-btn"
      >
        <Camera size={22} className="text-[#005CFF]" weight="duotone" />
        <div className="text-xs font-medium">Photo avant</div>
      </button>
      <button
        onClick={() => afterRef.current?.click()}
        disabled={busy}
        className="rounded-2xl bg-white/[0.03] border border-dashed border-white/15 hover:border-emerald-500/50 p-4 flex flex-col items-center gap-2 active:scale-95 transition-transform"
        data-testid="upload-after-btn"
      >
        <UploadSimple size={22} className="text-emerald-400" weight="duotone" />
        <div className="text-xs font-medium">Photo après</div>
      </button>
      <input ref={beforeRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0], "before")} />
      <input ref={afterRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => e.target.files?.[0] && upload(e.target.files[0], "after")} />
    </div>
  );
}
